import { DatePickerRange } from '../datepicker-range-advanced.interfaces';

export function quickSelectionRanges(ranges): DatePickerRange[] {
  return [
    { days: '0', label: ranges?.today },
    { days: '7', label: ranges?.sevenDays },
    { days: '30', label: ranges?.thirtyDays },
    { days: '60', label: ranges?.sixtyDays },
    { days: '90', label: ranges?.ninetyDays },
  ];
}
